<ion-content class="media-query-read-page">
  <div class="media-query-read-container">
    <button class="close-button" (click)="closeModal()">
      X
    </button>
    <img
      *ngIf="type === 'image'"
      [src]="path"
      alt="expanded image"
      class="reader-img"
    />
    <div>
      <video
        autoplay
        controls
        *ngIf="type === 'video'"
        [src]="path"
        class="reader-vedio"
      ></video>
    </div>
    <div class="controls-buttons" *ngIf="controls">
      <button class="button next-medial" (click)="nextMedia()">
        <img src="../../../assets/icon/arrowBlackR.svg" alt="arrowBlackR" />
      </button>
      <button class="button prev-medial" (click)="prevMedia()">
        <img src="../../../assets/icon/arrowBlackL.svg" alt="arrowBlackL" />
      </button>
    </div>
  </div>
</ion-content>
